module.exports = __webpack_public_path__ + "static/media/logoIvace.153a0239.png";